<template>
  <div>
    <Form
      class="c-form c-form--form"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="100"
    >
      <Form-item label="名称" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入名称"
        />
      </Form-item>
      <Form-item label="拉丁名称" prop="latinName">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.latinName"
          placeholder="请输入拉丁名称"
        />
      </Form-item>
      <Form-item label="编号" prop="no">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.no"
          placeholder="请输入编号"
        />
      </Form-item>
      <Form-item label="调查号" prop="surveyNo">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.surveyNo"
          placeholder="请输入调查号"
        />
      </Form-item>
      <Form-item label="图片" prop="pictureIds">
        <c-uploader
          class="c-form__input"
          :key="`picture-${cForm.id}`"
          multiple
          placeholder="请选择文件（可上传多张图片）"
          :max-size="1024 * 10"
          :default-file-ids="cForm.model.pictureIds"
          @change="
            value => {
              handleFormUploaderChange('pictureIds', value);
            }
          "
        ></c-uploader>
      </Form-item>
      <Form-item label="树种" prop="typeId">
        <c-tree-type-select
          class="c-form__input"
          :alias="alias"
          placeholder="请选择树种"
          v-model="cForm.model.typeId"
          @change="
            value => {
              $set(cForm.model, 'typeId', value);
            }
          "
        ></c-tree-type-select>
      </Form-item>
      <Form-item label="科属" prop="categoryId">
        <c-category-select
          class="c-form__input"
          :alias="alias"
          placeholder="请选择科属"
          v-model="cForm.model.categoryId"
          @change="
            value => {
              $set(cForm.model, 'categoryId', value);
            }
          "
        ></c-category-select>
      </Form-item>
      <Form-item label="保护等级" prop="protectionLevelId">
        <c-tree-protection-select
          class="c-form__input"
          :alias="alias"
          placeholder="请选择保护等级"
          v-model="cForm.model.protectionLevelId"
          @change="
            value => {
              $set(cForm.model, 'protectionLevelId', value);
            }
          "
        ></c-tree-protection-select>
      </Form-item>
      <Form-item label="文字颜色" prop="textColorId">
        <c-tree-text-color
          class="c-form__input"
          :alias="alias"
          placeholder="请选择文字颜色"
          v-model="cForm.model.textColorId"
          @change="
            value => {
              $set(cForm.model, 'textColorId', value);
            }
          "
        ></c-tree-text-color>
      </Form-item>
      <Form-item label="树龄" prop="age">
        <InputNumber :min="0" :max="100000" v-model="cForm.model.age" />
        岁
      </Form-item>
      <Form-item label="树高" prop="height">
        <InputNumber :min="0" :max="100000" v-model="cForm.model.height" />
        CM
      </Form-item>
      <Form-item label="胸围" prop="bustSize">
        <InputNumber :min="0" :max="100000" v-model="cForm.model.bustSize" />
        CM
      </Form-item>
      <Form-item label="冠幅" prop="crownWidth">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.crownWidth"
          placeholder="请输入冠幅"
        />
      </Form-item>
      <Form-item label="全景图链接" prop="panorama">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.panorama"
          placeholder="请输入全景图链接"
        />
      </Form-item>
      <Form-item label="生长位置" prop="address">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.address"
          placeholder="请输入生长位置"
        />
      </Form-item>
      <Form-item label="经纬度" prop="latLng">
        <Input
          class="c-form__input"
          :value="
            [cForm.model.latLng.lat || '', cForm.model.latLng.lng || '']
              .filter(item => !!item)
              .join(', ')
          "
          readonly
          placeholder="请选择经纬度"
          @on-focus="showMap"
        />
        <c-map ref="map" @select="selectLatLng"></c-map>
      </Form-item>
      <Form-item label="详情" prop="content">
        <c-editor
          :html="cForm.model.content"
          @change="
            html => {
              $set(cForm.model, 'content', html);
              $refs.form.validateField('content');
            }
          "
        ></c-editor>
      </Form-item>
      <Form-item>
        <Button class="u-mr5" type="primary" @click="submit">
          保存
        </Button>
        <Button
          @click="id ? $helpers.goBack() : $router.push(`/trees/trees/list`)"
        >
          返回
        </Button>
      </Form-item>
    </Form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import RouteParamsMixin from "@/mixins/route-params";
import FormMixin from "@/mixins/form";
import { mapState } from "vuex";

const module = "trees";

@Component({
  mixins: [RouteParamsMixin, FormMixin],
  computed: mapState({
    detail: state => state[module].detail
  })
})
export default class ArticlesForm extends Vue {
  data() {
    return {
      cForm: {
        model: this.getFormInitModel(),
        rules: {
          name: [
            {
              required: true,
              message: "名称不能为空"
            }
          ],
          content: [
            {
              required: true,
              message: "详情不能为空"
            }
          ]
        }
      }
    };
  }

  created() {
    this.id && this.getDetail(module, this.id);
  }

  getFormInitModel() {
    return {
      latLng: {
        lat: undefined,
        lng: undefined
      },
      content: "",
      age: 0,
      height: 0,
      bustSize: 0
    };
  }

  showMap() {
    this.$refs.map.show();
    this.$refs.map.create();
  }

  selectLatLng(latLng) {
    this.cForm.model.latLng = latLng;
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const {
          model: { id, ...restModel }
        } = this.cForm;

        await this.$store.dispatch(`${module}/${id ? "put" : "post"}`, {
          id,
          body: restModel
        });

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list");
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
